import AppButton from "@toothfairy/shared-ui/AppButton";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useCallback } from "react";
import Constants from "../../Constants";

const ToothFairyButton = ({
  style,
  wrapperStyle,
  isDeletion,
  isSecondary,
  paddingLeft = 14,
  paddingRight = 14,
  icon,
  isDisabled,
  backgroundColor,
  fontColor,
  ...props
}) => {
  const { currentTheme, mode } = AppTheme.useTheme();
  const generateBtnFontColor = useCallback(() => {
    if (isDeletion) {
      return currentTheme?.theme?.red;
    } else {
      return currentTheme?.theme?.white;
    }
  }, [isDisabled, isDeletion, isSecondary, mode, JSON.stringify(currentTheme)]);
  return (
    <AppButton
      awesomeIcon={icon}
      fontColor={fontColor || generateBtnFontColor()}
      awesomeIconColor={
        isDeletion ? currentTheme?.theme?.red : currentTheme?.theme?.white
      }
      backgroundColor={
        backgroundColor
          ? backgroundColor
          : isDeletion
          ? currentTheme?.theme?.transparent
          : isSecondary
          ? currentTheme?.theme?.transparent
          : currentTheme?.theme?.primary
      }
      borderColor={isSecondary ? currentTheme?.theme?.border_color : undefined}
      forcedDisabledBackgroundColor={currentTheme?.theme?.lightGrey}
      is_secondary={isSecondary}
      isDisabled={isDisabled}
      btnContentStyle={{
        paddingLeft,
        paddingRight,
      }}
      style={[
        {
          height: Constants.appButtonHeight,
          width: "auto",
          marginHorizontal: 10,
        },
        style,
      ]}
      // btnLabelStyle={{ fontSize: 16 }}
      wrapperStyle={[{ width: "fit-content", minWidth: 80 }, wrapperStyle]}
      {...props}
    />
  );
};

export default ToothFairyButton;
